export default __webpack_public_path__ + "static/media/Бор+Моліб_40л.bc784e8f.jpg";